import React, { createContext, useEffect, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useUnleashContext } from '@unleash/proxy-client-react'
import AuthFaberApi from 'api/faber/AuthAPI'
import AuthAPI from 'api/orbitV1/AuthAPI'
import axios from 'axios'
import PropTypes from 'prop-types'

import OrbitSession from '../hooks/useCookies'

interface AuthContextType {
  auth: {
    role: string[]
  }
  setAuth: (body: { role: string[] }) => void
}

const defaultState = {
  auth: {
    role: []
  },
  // eslint-disable-next-line no-empty-pattern
  setAuth: ({ role: [] }) => null
}

export const AuthContext = createContext<AuthContextType>(defaultState)

/**
 * Permissions the constituent routes with the role of the logged-in user
 * @param {node} children - page routes
 * @returns Provider
 */
const AuthProvider = ({ children }) => {
  const role = OrbitSession.get('role')
  const orgId = OrbitSession.get('orgId')
  const provider = OrbitSession.get('provider')
  const faberToken = OrbitSession.get('faberToken')
  let updateContext
  if (provider === 'UL') {
    updateContext = useUnleashContext()
  }

  const [auth, setAuth] = useState({ role: [role] })
  // to check if user is logged in when first load page, token is still valid
  const { mutate: validateToken } = useMutation(AuthFaberApi.validateToken, {
    onError: () => {
      OrbitSession.delAll()
      AuthAPI.logUserOut()
    }
  })

  useEffect(() => {
    setAuth({ role: [role] })
    axios.defaults.headers.common['Authorization'] = `Bearer ${faberToken}`
    validateToken({
      faberToken: faberToken
    })
  }, [faberToken])

  useEffect(() => {
    if (provider === 'UL') {
      updateContext({ userId: orgId })
    }
  }, [])

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      <>{children}</>
    </AuthContext.Provider>
  )
}

AuthProvider.propTypes = {
  children: PropTypes.node
}

export default AuthProvider
